import styled from 'styled-components';
import { Card, Table } from 'reactstrap';
import { color } from '~/assets/styles/colors';

export const StyledTable = styled(Table)`
	border-radius: 0px 18px 18px 18px;
	padding: 8px;
	margin: 0px;

    &&& {
        th,
        td {
            padding: 3px;
			&::after {
				width: 0 !important;
			}
			font-size: 13px ;
        }

        tbody tr {
            height: 40px;
        }
        thead tr {
			height: 40px;
        }
		thead th {
			font-weight: bold;
			&:first-child {
                border-top-left-radius: 15px;
            }

            &:last-child {
                border-top-right-radius: 15px;
            }
        }

		@media screen and (max-width: 543px) {
			th,
			td {
				padding: 3px;
				font-size: 9px;
			}
		}
    }
`;


export const StyledCard = styled(Card)`
	margin-bottom: 20px;
	border-radius: 10px 10px 10px 0;
	padding: 18px;
	overflow-y: auto;
	height:  380px;
	border-collapse: collapse;

	::-webkit-scrollbar {
		width: 10px;
	}

	::-webkit-scrollbar-track {
		background: #fff;
	}

	::-webkit-scrollbar-thumb {
		background-color: ${color.secondary};
		border-radius: 20px;
		border: 2px solid ${color.primary};
	}

	@media screen and (max-width: 1000px) {
		overflow-x: hidden;
		height: auto;
	}
`
